<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">회원공지사항</span>
            <span class="txt">회원들에게 공지사항, 업데이트 등 여러 사항을 전달할 수 있습니다.</span>
        </div>
        <loading-spinner v-if="!noticeDetail"></loading-spinner>
        <div v-else class="com-table-content">
            <div class="com-btn-area">
                <div class="right-box"></div>
            </div>
            <table class="com-table view">
                <colgroup>
                    <col style="width: 170px" />
                    <col style="width: auto" />
                    <col style="width: 170px" />
                    <col style="width: auto" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>카테고리</th>
                        <td>{{ noticeDetail.boardCategory === null ? '' : noticeDetail.boardCategory.name }}</td>
                        <th>글쓴이</th>
                        <td>{{ noticeDetail.info.createdName }}</td>
                    </tr>
                    <tr>
                        <th>조회수</th>
                        <td>{{ noticeDetail.viewCount }}</td>
                        <th>등록일</th>
                        <td>{{ noticeDetail.info.createdAt | timestampFilter }}</td>
                    </tr>
                    <tr>
                        <th>첨부파일</th>
                        <td colspan="3">
                            <a
                                v-for="(file, index) in fileList"
                                :key="index"
                                :href="file.fileUrl"
                                class="file-down"
                                style="cursor: pointer"
                            >
                                {{ file.name }}
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <th>제목</th>
                        <td colspan="3">{{ noticeDetail.title }}</td>
                    </tr>
                    <tr>
                        <td class="no-padding no-side-border" colspan="4">
                            <div class="txt-view">
                                <div class="ck-content" v-html="noticeDetail.content"></div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link class="com-btn gray" to="/madmin/setting/member/notice/list">목록</router-link>
                    <router-link
                        v-if="isWriteAuth && cId === $route.params.centerId"
                        :to="`/madmin/setting/member/notice/edit/${noticeId}`"
                        class="com-btn blue"
                    >
                        수정
                    </router-link>
                    <button
                        v-if="isWriteAuth && cId === $route.params.centerId"
                        class="com-btn red"
                        @click="onClickDelete(noticeDetail.id)"
                    >
                        삭제
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';

export default {
    name: 'SettingMemberNoticeDetail',
    components: { LoadingSpinner },
    props: {},
    computed: {
        isWriteAuth() {
            const { getters } = this.$store;
            return (
                getters['auth/isCareAdmin'] ||
                getters['auth/isSystemAdmin'] ||
                getters['auth/isCenterAdmin'] ||
                getters['auth/isCenterStaff']
            );
        },
        isReadAuth() {
            const { getters } = this.$store;
            return this.isWriteAuth || getters['auth/isCustomer'];
        },
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    mounted() {
        this.centerId = parseInt(this.cId); // 회원 공지사항 centerId
        this.fetchNoticeDetail();
    },
    data() {
        return {
            centerId: null,
            isLoading: false,
            noticeId: this.$route.params.id,
            noticeDetail: null,
            fileList: null,
        };
    },
    methods: {
        // 공지사항 상세 Fetch
        async fetchNoticeDetail() {
            try {
                this.isLoading = true;
                const { data } = await this.sendGetNoticeDetail(this.noticeId);
                this.noticeDetail = data;

                if (data.fileGroupId) {
                    // fileGroupId가 있으면 파일 목록 fetch
                    const fileGroupData = await this.sendGetNoticeDetailFileGroup(data.fileGroupId);
                    this.fileList = fileGroupData.data;
                }
                console.log('===> Success Loading Center Notice Detail', data);
                this.isLoading = false;
            } catch (error) {
                console.log(error);
            }
        },

        // 공지사항 삭제
        async onClickDelete(id) {
            try {
                this.isLoading = true;
                const { data } = await this.sendGetDeleteNotice(id);
                alert('공지사항을 삭제했습니다.');
                this.isLoading = false;
                console.log('===> Success Delete Center Notice', data);
                this.$router.push({ name: 'SettingMemberNoticeList' });
            } catch (error) {
                console.log(error);
            }
        },

        // 공지사항 상세 API
        sendGetNoticeDetail(id) {
            return api.get(`/admin/api/center/${this.$route.params.centerId}/board/notice/${id}/view`);
        },

        // 공지사항 상세 첨부 파일 리스트 API
        sendGetNoticeDetailFileGroup(fileGroupId) {
            return api.get(`/admin/api/board/file-group/${fileGroupId}`);
        },

        // 공지사항 삭제 API
        sendGetDeleteNotice(id) {
            return api.delete(`/admin/api/center/${this.$route.params.centerId}/board/notice/${id}`);
        },
    },
};
</script>
<style scoped src="@/assets/js/ckeditor/ckeditor.css"></style>
<!-- ckeditor5 css -->
<style lang="scss" scoped>
a.file-down::after {
    content: ',' attr(file-down);
    margin-right: 5px;
}

a.file-down:last-of-type::after {
    content: '';
}
</style>
